/* eslint-disable react/jsx-no-target-blank */
import { BackofficePermissionsEnum as Permissions } from '../../../../app/common/enums/backOfficePermissionsEnum'
import usePermissions from '../../../../app/common/hooks/usePermissions'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSubMain } from './AsideMenuItemWithSubMain'

export function AsideMenuMain() {
  const { hasPermission } = usePermissions()

  return (
    <>
      {/* CLIENTES */}
      {hasPermission(Object.values(Permissions.USER_CUSTOMER)) && (
        <AsideMenuItemWithSubMain to={['/client']} title='Clientes' fontIcon=' bi-people fs-3'>
          <AsideMenuItem to='/client/list' title=' Clientes' fontIcon='bi-people fs-3' />
          {hasPermission(Permissions.USER_CUSTOMER.IMPORT) && (
            <AsideMenuItem
              to='/client/import'
              title=' Importar clientes'
              fontIcon='bi-person-plus-fill fs-3'
            />
          )}
        </AsideMenuItemWithSubMain>
      )}

      {/* FONDOS */}
      {hasPermission(Object.values(Permissions.FUND)) && (
        <AsideMenuItemWithSubMain to={['/funds']} title='Fondos' fontIcon='bi bi-cash-coin fs-3'>
          {/* <AsideMenuItem to='/funds/list' title='Listado de fondos' fontIcon='bi-list-stars fs-3' /> */}
          <AsideMenuItem
            to='/funds/list-v2'
            title='Listado de fondos'
            fontIcon='bi-list-stars fs-3'
          />
          {hasPermission(Permissions.FUND.RECOMMENDED) && (
            <AsideMenuItem
              to='/funds/recommended-config'
              title='Fondos Recomendados'
              fontIcon='bi-bullseye fs-3'
            />
          )}
          {/* {hasPermission(Permissions.FUND.RECOMMENDED) && (
            <AsideMenuItem
              to='/funds/recommended'
              title='Fondos recomendados'
              fontIcon='bi-bullseye fs-3'
            />
          )} */}
        </AsideMenuItemWithSubMain>
      )}

      {/* MOVIMIENTOS */}
      {hasPermission(Permissions.MOVIMIENTOS_ALL) && (
        <AsideMenuItemWithSubMain
          to={['/movements']}
          title='Movimientos'
          fontIcon='bi-cash-stack fs-3'
        >
          <AsideMenuItem
            to='/movements/list'
            title='Suscripciones y rescates'
            fontIcon='bi-cash-stack fs-3'
          />
          {hasPermission(Permissions.ACCOUNT_VALIDATED.LIST) && (
            <AsideMenuItem
              to='/movements/bank-accounts'
              title='Cuentas bancarias'
              fontIcon='bi-bank fs-3'
            />
          )}
        </AsideMenuItemWithSubMain>
      )}

      {/* CONFIGURACION */}
      {hasPermission(Permissions.CONFIG_ALL) && (
        <AsideMenuItemWithSubMain
          to={['/user', '/role', '/configuration', '/prospect', '/audit']}
          title='Config'
          fontIcon='bi-gear'
        >
          {hasPermission(Object.values(Permissions.USER_PERSON)) && (
            <AsideMenuItem to='/user/list' title='Usuarios' fontIcon='bi-people fs-3' />
          )}
          {hasPermission(Object.values(Permissions.ROLE)) && (
            <AsideMenuItem to='/role/list' title='Roles y permisos' fontIcon='bi-archive fs-3' />
          )}
          {hasPermission(Object.values(Permissions.USER_PROSPECT)) && (
            <AsideMenuItem
              to='/prospect/list'
              title='Prospectos'
              fontIcon='bi-person-bounding-box fs-3'
            />
          )}
          {hasPermission(Object.values(Permissions.RISK_TOLERANCE)) && (
            <AsideMenuItem
              to='/configuration/forms'
              title='Tolerancia al Riesgo'
              fontIcon='  bi-ui-checks fs-3'
            />
          )}
          {hasPermission(Object.values(Permissions.USER_EXECUTIVE)) && (
            <AsideMenuItem
              to='/user/businessExecutive'
              title=' Asesores / Ejecutivos'
              fontIcon='bi-graph-up-arrow fs-3'
            />
          )}
          {hasPermission(Object.values(Permissions.GENERAL_CONFIG)) && (
            <AsideMenuItem
              to='/configuration/general'
              title='Configuración general'
              fontIcon='bi-gear-wide fs-3'
            />
          )}
          {hasPermission(Object.values(Permissions.AUDIT)) && (
            <AsideMenuItem to='/audit/list' title='Auditoría' fontIcon='bi-journal-text fs-3' />
          )}
          {hasPermission(Permissions.GENERAL_CONFIG.UPDATE_BANNER) && (
            <AsideMenuItem
              to='/configuration/image-carousel'
              title='Carrusel de imágenes'
              fontIcon='bi bi-images fs-3'
            />
          )}
        </AsideMenuItemWithSubMain>
      )}

      {/* LOGGER */}
      {hasPermission(Object.values(Permissions.LOGGER)) && (
        <AsideMenuItem to='/logs/list' title='Logger' fontIcon='bi-hdd-stack fs-3' />
      )}
    </>
  )
}
